// extracted by mini-css-extract-plugin
export default {"inputText":"styles_inputText__obHMK"};